<template>
  <section class="personal-credential-item q-pa-md row justify-between q-mb-md">
    <div class="flex-1 q-mr-md">
      <component :is="component" :credential="credential" />
    </div>
    <div class="flex items-center">
      <q-btn
        class="delete-credential-btn"
        :aid="`delete-credential-${credential.meta.name}`"
        icon="fa-solid fa-trash-can"
        flat
        round
        color="black-54"
        size="12px"
        @click="
          $emit('delete-credential', { kind: credential.meta.kind, id: credential.meta.id, name: credential.meta.name })
        "
      >
        <q-tooltip> Delete credential </q-tooltip>
      </q-btn>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { GenericSecretBox } from "../generic-secret-box";
import { DockerRegistryBox } from "../docker-registry-box";
import type { CredentialsListResponseEntry } from "@/swagger-models/assets-service-client";
import { AssetKind } from "@/swagger-models/assets-service-client";

export default defineComponent({
  name: "personal-credential-item",
  components: {
    GenericSecretBox,
    DockerRegistryBox,
  },
  props: {
    credential: {
      type: Object as PropType<CredentialsListResponseEntry>,
      required: true,
    },
  },
  data() {
    return {
      AssetKind,
    };
  },
  computed: {
    component(): typeof GenericSecretBox | typeof DockerRegistryBox | null {
      switch (this.credential.meta.kind) {
        case AssetKind.GenericSecret:
          return GenericSecretBox;
        case AssetKind.DockerRegistry:
          return DockerRegistryBox;
        default:
          return null;
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.personal-credential-item {
  background-color: $body-background-color;
}
</style>
